import React from 'react';
import ReactMarkdown from 'react-markdown';

interface MarkdonRenderProps {
  text: string;
}

const allowedEments = [
  'text',
  'strong',
  'link',
  'ul',
  'br',
  'li',
  'ol',
  'a',
];

const getLinkTarget = (href?: string) => {
  if (!href) return '_blank';
  if (href.startsWith('tel:') || href.startsWith('mailto:')) return '_self';
  return '_blank';
};

const MarkdownRender: React.FC<MarkdonRenderProps> = ({ text }) => {
  return (
    <>
      <ReactMarkdown
        linkTarget={getLinkTarget}
        components={{
          p: React.Fragment,
        }}
        allowedElements={allowedEments}
        unwrapDisallowed
      >{text}
      </ReactMarkdown>
    </>
  );
};

export default MarkdownRender;
